/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Service_Add_XmgInputs */

const vi_carrier_service_add_xmg = /** @type {(inputs: Carrier_Service_Add_XmgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu tiền xem hàng`)
};

/**

* @param {Carrier_Service_Add_XmgInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_service_add_xmg = /** @type {((inputs?: Carrier_Service_Add_XmgInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Service_Add_XmgInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_service_add_xmg(inputs)
});